import { render, staticRenderFns } from "./TripNotFoundSection.vue?vue&type=template&id=d6624f28&"
import script from "./TripNotFoundSection.vue?vue&type=script&lang=ts&"
export * from "./TripNotFoundSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports